<template>
  <div>
    <!-- Navbar -->
    <nav class="app-header main-header navbar navbar-expand header-height ml-0">
      <!-- Left navbar links -->
      <ul class="navbar-nav">
        <!--<li class="nav-item">
          <a class="nav-link" data-widget="pushmenu" href="#" role="button">
            <i class="fas fa-bars"></i>
          </a>
        </li>-->
        <li class="nav-item dropdown header-list">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="navbarDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Hızlı İşlemler
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a
              class="dropdown-item"
              href="#"
              @click="openBonusModal"
              v-if="
                auth.BonusRequestAdd != null && auth.BonusRequestAdd.isWrite
              "
              >Bonus Talep Et</a
            >
            <a
              class="dropdown-item"
              href="#"
              @click="openManuelBonusModal"
              v-if="auth.ManuelBonusAdd != null && auth.ManuelBonusAdd.isWrite"
              >Manuel Bonus Ekle</a
            >

            <a
              class="dropdown-item"
              href="#"
              @click="openFileUploadModal"
              v-if="
                auth.BonusRequestAdd != null && auth.BonusRequestAdd.isWrite
              "
              >Çekiliş Sistemi</a
            >

            <div
              class="dropdown-divider"
              v-if="auth.DepositRemove != null && auth.DepositRemove.isWrite"
            ></div>
            <a
              class="dropdown-item"
              href="#"
              @click="openDepositRemoveModal"
              v-if="auth.DepositRemove != null && auth.DepositRemove.isWrite"
              >Yatırım Kaydı Sil</a
            >
          </div>
        </li>
        <li class="nav-item">
          <div class="switch-container">
            <label class="switch">
              <input
                type="checkbox"
                @change="toggleTheme"
                :checked="dClass === 'true' ? true : false"
              />
              <span class="slider"></span>
            </label>

            <i
              class="fas"
              :class="{
                'fa-moon text-dark': dClass === 'false' || dClass === false,
                'fa-sun text-warning': dClass === 'true' || dClass === true,
              }"
              style="font-size: 1.5rem"
            ></i>
          </div>
        </li>
      </ul>

      <!-- Right navbar links -->
      <ul class="navbar-nav ml-auto">
        <!-- Navbar Search -->
        <li class="nav-item">
          <select
            v-model="site"
            @change="siteChange"
            class="form-control header-list"
          >
            <option
              v-for="item in $store.getters.getSites"
              :key="item.slug"
              :value="item.slug"
            >
              {{ item.name }}
            </option>
          </select>
        </li>
        <li class="nav-item">
          <a
            class="nav-link btn-logout"
            @click="logout"
            role="button"
            title="Çıkış Yap"
          >
            <i class="fas fa-sign-out-alt"></i>
          </a>
        </li>
      </ul>
    </nav>
    <!-- /.navbar -->

    <!--Modal-->
    <div class="modal fade" id="request-bonus">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Bonus Tetikle</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onSubmit">
              <div class="form-group">
                <select
                  v-model="site"
                  class="form-control"
                  @change="siteChange"
                >
                  <option
                    v-for="item in $store.getters.getSites"
                    :key="item.slug"
                    :value="item.slug"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <input
                  @blur="$v.request.code.$touch()"
                  v-model="$v.request.code.$model"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': $v.request.code.$error }"
                  placeholder="Müşteri ID giriniz"
                />
                <small
                  v-if="!$v.request.code.required && $v.request.code.$error"
                  class="form-text text-danger"
                  >Bu alan zorunludur...</small
                >
              </div>

              <div class="form-group">
                <select
                  @blur="$v.request.bonus.$touch()"
                  v-model="$v.request.bonus.$model"
                  class="form-control"
                >
                  <option :value="null">Bonus Seçiniz</option>
                  <option
                    v-for="data in bonuses"
                    :key="data.id"
                    :value="data.id"
                  >
                    {{ data.name }}
                  </option>
                </select>
                <small
                  v-if="!$v.request.bonus.required && $v.request.bonus.$error"
                  class="form-text text-danger"
                  >Bu alan zorunludur...</small
                >
              </div>
            </form>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              İptal
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="loading || $v.request.$invalid"
              @click="requestBonus"
            >
              Talep Et
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal fade" id="manuel-bonus">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Manuel Bonus Tetikle</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onSubmit">
              <small class="text-danger"
                >* Manuel bonus müşteri hesabına direk eklenmektedir! Seçimlere
                dikkat edilmelidir.
              </small>
              <div class="form-group">
                <select
                  v-model="site"
                  class="form-control"
                  @change="siteChange"
                >
                  <option
                    v-for="item in $store.getters.getSites"
                    :key="item.slug"
                    :value="item.slug"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <input
                  @blur="$v.manuel.code.$touch()"
                  v-model="$v.manuel.code.$model"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': $v.manuel.code.$error }"
                  placeholder="Müşteri ID giriniz"
                />
                <small
                  v-if="!$v.manuel.code.required && $v.manuel.code.$error"
                  class="form-text text-danger"
                  >Bu alan zorunludur...</small
                >
              </div>
              <div class="form-group">
                <select
                  @blur="$v.manuel.bonus.$touch()"
                  v-model="$v.manuel.bonus.$model"
                  class="form-control"
                  :class="{ 'is-invalid': $v.manuel.bonus.$error }"
                >
                  <option :value="null">Bonus Seçiniz</option>
                  <option
                    v-for="data in bonuses"
                    :key="data.id"
                    :value="data.id"
                  >
                    {{ data.name }}
                  </option>
                </select>
                <small
                  v-if="!$v.manuel.bonus.required && $v.manuel.bonus.$error"
                  class="form-text text-danger"
                  >Bu alan zorunludur...</small
                >
              </div>

              <div class="form-group">
                <input
                  @blur="$v.manuel.transaction.$touch()"
                  v-model="$v.manuel.transaction.$model"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': $v.manuel.transaction.$error }"
                  placeholder="İşlem ID giriniz"
                />
                <small
                  v-if="
                    !$v.manuel.transaction.required &&
                    $v.manuel.transaction.$error
                  "
                  class="form-text text-danger"
                  >Bu alan zorunludur...</small
                >
              </div>
              <div v-if="shouldDisplayDebitAmount" class="form-group">
                <input
                  @blur="$v.manuel.debitAmount.$touch()"
                  v-model="manuel.debitAmount"
                  type="number"
                  class="form-control"
                  placeholder="Borç Tutarını Girin"
                />
              </div>
              <div class="form-group">
                <input
                  @blur="$v.manuel.amount.$touch()"
                  v-model="$v.manuel.amount.$model"
                  type="number"
                  class="form-control"
                  :class="{ 'is-invalid': $v.manuel.amount.$error }"
                  placeholder="Bonus Tutarı giriniz"
                />
                <small
                  v-if="!$v.manuel.amount.required && $v.manuel.amount.$error"
                  class="form-text text-danger"
                  >Bu alan zorunludur...</small
                >
              </div>
              <div class="form-group">
                <textarea
                  v-model="manuel.note"
                  type="number"
                  class="form-control"
                  placeholder="Bonus Notu giriniz"
                >
                </textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              İptal
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="loading || $v.manuel.$invalid"
              @click="requestManuelBonus"
            >
              Talep Et
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal fade" id="request-insiyatif">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">İnsiyatif Sorgulama Tetikle</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onSubmit">
              <div class="form-group">
                <select
                  v-model="site"
                  class="form-control"
                  @change="siteChange"
                >
                  <option
                    v-for="item in $store.getters.getSites"
                    :key="item.slug"
                    :value="item.slug"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <input
                  @blur="$v.insiyatif.code.$touch()"
                  v-model="$v.insiyatif.code.$model"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': $v.insiyatif.code.$error }"
                  placeholder="Müşteri ID giriniz"
                />
                <small
                  v-if="!$v.insiyatif.code.required && $v.insiyatif.code.$error"
                  class="form-text text-danger"
                  >Bu alan zorunludur...</small
                >
              </div>
            </form>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              İptal
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="$v.insiyatif.$invalid"
              @click="requestInsiyatifBonus"
            >
              Talep Et
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal fade" id="request-tc">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">TC Kimlik Doğrulama</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onSubmit">
              <div class="form-group">
                <input
                  @blur="$v.tc.tckn.$touch()"
                  v-model="$v.tc.tckn.$model"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': $v.tc.tckn.$error }"
                  placeholder="Tc Kimlik No giriniz"
                />
                <small
                  v-if="!$v.tc.tckn.required && $v.tc.tckn.$error"
                  class="form-text text-danger"
                  >Bu alan zorunludur...</small
                >
                <small
                  v-if="!$v.tc.tckn.numeric && $v.tc.tckn.$error"
                  class="form-text text-danger"
                  >Sadece rakam girilebilir...</small
                >
              </div>
              <div class="form-group">
                <input
                  @blur="$v.tc.year.$touch()"
                  v-model="$v.tc.year.$model"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': $v.tc.year.$error }"
                  placeholder="Doğum Yılı giriniz"
                />
                <small
                  v-if="!$v.tc.year.required && $v.tc.year.$error"
                  class="form-text text-danger"
                  >Bu alan zorunludur...</small
                >
                <small
                  v-if="!$v.tc.year.numeric && $v.tc.year.$error"
                  class="form-text text-danger"
                  >Sadece rakam girilebilir...</small
                >
                <small
                  v-if="!$v.tc.year.between && $v.tc.year.$error"
                  class="form-text text-danger"
                  >Doğum yılı {{ $v.tc.year.$params.between.min }} ile
                  {{ $v.tc.year.$params.between.max }} arasında
                  olmalıdır...</small
                >
              </div>
              <div class="form-group">
                <input
                  @blur="$v.tc.name.$touch()"
                  v-model="$v.tc.name.$model"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': $v.tc.name.$error }"
                  placeholder="Ad giriniz"
                />
                <small
                  v-if="!$v.tc.name.required && $v.tc.name.$error"
                  class="form-text text-danger"
                  >Bu alan zorunludur...</small
                >
              </div>
              <div class="form-group">
                <input
                  @blur="$v.tc.surname.$touch()"
                  v-model="$v.tc.surname.$model"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': $v.tc.surname.$error }"
                  placeholder="Soyad giriniz"
                />
                <small
                  v-if="!$v.tc.surname.required && $v.tc.surname.$error"
                  class="form-text text-danger"
                  >Bu alan zorunludur...</small
                >
              </div>
            </form>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              İptal
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="$v.tc.$invalid"
              @click="requestTc"
            >
              Sorgula
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal fade" id="request-tc-quick">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">TC Kimlik (Hızlı) Doğrulama</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onSubmit">
              <div class="form-group">
                <select
                  v-model="site"
                  class="form-control"
                  @change="siteChange"
                >
                  <option
                    v-for="item in $store.getters.getSites"
                    :key="item.slug"
                    :value="item.slug"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <input
                  @blur="$v.quick.code.$touch()"
                  v-model="$v.quick.code.$model"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': $v.quick.code.$error }"
                  placeholder="Müşteri ID giriniz"
                />
                <small
                  v-if="!$v.quick.code.required && $v.quick.code.$error"
                  class="form-text text-danger"
                  >Bu alan zorunludur...</small
                >
              </div>
              <div class="form-group">
                <input
                  @blur="$v.quick.tckn.$touch()"
                  v-model="$v.quick.tckn.$model"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': $v.quick.tckn.$error }"
                  placeholder="Tc Kimlik no giriniz"
                />
                <small
                  v-if="!$v.quick.tckn.required && $v.quick.tckn.$error"
                  class="form-text text-danger"
                  >Bu alan zorunludur...</small
                >
                <small
                  v-if="!$v.quick.tckn.numeric && $v.quick.tckn.$error"
                  class="form-text text-danger"
                  >Sadece rakam girilebilir...</small
                >
              </div>
            </form>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              İptal
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="$v.quick.$invalid"
              @click="requestTcQuick"
            >
              Sorgula
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal fade" id="request-deposit-remove">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Müşteri Yatırım Silme</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onSubmit">
              <div class="form-group">
                <select
                  v-model="site"
                  class="form-control"
                  @change="siteChange"
                >
                  <option
                    v-for="item in $store.getters.getSites"
                    :key="item.slug"
                    :value="item.slug"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <input
                  @blur="$v.deposit.code.$touch()"
                  v-model="$v.deposit.code.$model"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': $v.deposit.code.$error }"
                  placeholder="Müşteri ID giriniz"
                />
                <small
                  v-if="!$v.deposit.code.required && $v.deposit.code.$error"
                  class="form-text text-danger"
                  >Bu alan zorunludur...</small
                >
              </div>
              <div class="form-group">
                <input
                  @blur="$v.deposit.transaction.$touch()"
                  v-model="$v.deposit.transaction.$model"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': $v.deposit.transaction.$error }"
                  placeholder="Transaction ID's giriniz (123124534534, 23423423423)"
                />
                <small
                  v-if="
                    !$v.deposit.transaction.required &&
                    $v.deposit.transaction.$error
                  "
                  class="form-text text-danger"
                  >Bu alan zorunludur...</small
                >
              </div>
            </form>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              İptal
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="$v.deposit.$invalid"
              @click="requestDepositRemove"
            >
              Talep Et
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal fade" id="file-upload-modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Çekiliş Sistemi</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onFileUpload">
              <div class="w-100 position-relative mt-1">
                <!-- <div class="form-group">
                  <select v-model="cekilis" class="form-control">
                    <option v-for="item in cekilistTypes" :key="item.id" :value="item.id">
                      {{ item.bilet_amount }}
                    </option>
                  </select>
                </div> -->
                <div
                  class="w-100 position-absolute"
                  style="margin-top: -12px"
                  v-if="selectedFile"
                >
                  <span class="bg-secondary py-1 px-2 rounded-lg">
                    <i class="fas fa-file-upload text-light mr-2"></i>
                    {{ selectedFile.name || "file selected" }}
                  </span>
                  <button
                    class="btn btn-icon-danger text-danger"
                    @click="onClearSelection"
                    title="Clear file selection"
                  >
                    <i class="fas fa-times"></i>
                    Clear selection
                  </button>
                </div>
                <input
                  v-else
                  id="fileUploader"
                  type="file"
                  accept=".xls, .xlsx"
                  class="my-0"
                  style="display: flex"
                  ref="inputFile"
                  @change="(e) => handleFileUpload(e)"
                />
              </div>
            </form>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              İptal
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="loading || !canSendRequest"
              @click="sendData()"
            >
              <span v-if="!loading">Kaydet</span>
              <span v-else>
                <i class="fa fa-spinner fa-spin"></i> Uploading...
              </span>
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
import { required, numeric, between } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      site: this.$store.getters.getSite,
      auth: this.$store.getters.getModules,
      cekilistTypes: null,
      selectedFile: null,
      cekilis: 0,
      loading: false,
      dClass: JSON.parse(localStorage.getItem("dark-mode")),
      request: {
        code: "",
        bonus: null,
      },
      manuel: {
        code: "",
        bonus: null,
        amount: "",
        transaction: "",
        type: null,
        debitAmount: "",
        freespin: 0,
        note: "",
      },
      insiyatif: {
        code: "",
      },
      quick: {
        code: "",
        tckn: "",
      },
      tc: {
        tckn: "",
        year: "",
        name: "",
        surname: "",
      },
      deposit: {
        code: "",
        transaction: "",
      },
      bonuses: [],
    };
  },
  validations: {
    request: {
      code: {
        required,
      },
      bonus: {
        required,
      },
    },
    manuel: {
      code: {
        required,
      },
      bonus: {
        required,
      },
      transaction: {
        required,
      },

      amount: {
        required,
      },
    },
    insiyatif: {
      code: {
        required,
      },
    },
    quick: {
      code: {
        required,
      },
      tckn: {
        required,
        numeric,
      },
    },
    tc: {
      tckn: { required, numeric },
      year: { required, numeric, between: between(1900, 2100) },
      name: { required },
      surname: { required },
    },
    deposit: {
      code: { required },
      transaction: { required },
    },
  },
  mounted() {
    const isDarkMode = localStorage.getItem("dark-mode"); // returns boolean
    this.darkMode(isDarkMode);
  },
  computed: {
    console: () => console,
    window: () => window,
    canSendRequest: function () {
      return this.selectedFile !== null;
    },
    shouldDisplayDebitAmount() {
      return (
        this.manuel.bonus === 11 ||
        this.manuel.bonus === 2 ||
        this.manuel.bonus === 5
      );
    },
  },
  methods: {
    onChangeTheme(theme, mode) {
      const baseURL = `src/assets/dist/css/`;
      const url = `${baseURL}${theme}`;
      const elementId = "theme-css";
      const linkElement = document.getElementById(elementId);
      const cloneLinkElement = linkElement.cloneNode(true);
      const oldThemeUrl = linkElement.getAttribute("href");
      const newThemeUrl = linkElement
        .getAttribute("href")
        .replace(oldThemeUrl, url);
      cloneLinkElement.setAttribute("id", elementId + "-clone");
      cloneLinkElement.setAttribute("href", newThemeUrl);
      cloneLinkElement.addEventListener("load", () => {
        linkElement.remove();
        cloneLinkElement.setAttribute("id", elementId);
      });
      linkElement.parentNode.insertBefore(
        cloneLinkElement,
        linkElement.nextSibling
      );
    },
    darkMode(theme) {
      localStorage.setItem("dark-mode", theme);
      if (theme === "true" || theme === true) {
        this.dClass = theme;
        this.onChangeTheme("adminltedark.min.css", "dark");
      } else if (theme === "false" || theme === false) {
        this.dClass = theme;
        this.onChangeTheme("adminlte.min.css", "light");
      }
    },
    toggleTheme(e) {
      const theme = e.target.checked;
      this.darkMode(theme);
    },
    getCekilis() {
      this.$http.get("Report/ListCekilis/").then((response) => {
        this.cekilistTypes = response.data;
      });
    },
    getAllBonus() {
      this.$http.get("Bonus/ListAllBonuses/").then((response) => {
        this.bonuses = response.data;
      });
    },
    openBonusModal() {
      this.request = {
        code: "",
        bonus: null,
      };
      this.$v.$reset();
      this.getAllBonus();
      $("#request-bonus").modal();
    },
    openManuelBonusModal() {
      this.manuel = {
        code: "",
        bonus: null,
        amount: "",
        debitAmount: "",
        type: null,
        transaction: "",
        freespin: 0,
        note: "",
      };
      this.$v.$reset();
      this.getAllBonus();
      $("#manuel-bonus").modal();
    },
    openInsiyatifModal() {
      this.insiyatif = {
        code: "",
      };
      this.$v.$reset();

      $("#request-insiyatif").modal();
    },
    openTcQuickModal() {
      this.quick = {
        code: "",
        tckn: "",
      };
      this.$v.$reset();

      $("#request-tc-quick").modal();
    },
    openTcModal() {
      this.tc = {
        tckn: "",
        year: "",
        name: "",
        surname: "",
      };
      this.$v.$reset();

      $("#request-tc").modal();
    },
    openDepositRemoveModal() {
      this.deposit = {
        code: "",
        transaction: "",
      };
      this.$v.$reset();

      $("#request-deposit-remove").modal();
    },
    requestBonus() {
      /*this.$http.post("Bonus/RequestAddBonus/", this.request).then(
        (response) => {
          toastr.success("Bonus talebiniz başarıyla alındı.");

          $("#request-bonus").modal("hide");
        },
        (err) => {
          toastr.error(err.data.Message);
        }
      );*/

      if (this.loading) {
        this.console.log("Already request is in Creation!");
        return;
      }

      this.loading = true;

      this.$http
        .get(
          "Bonus/Request/" +
            this.site +
            "/" +
            this.request.bonus +
            "/" +
            this.request.code +
            "/bonus-request/-"
        )
        .then(
          (response) => {
            toastr.success("Bonus talebiniz başarıyla alındı.");

            $("#request-bonus").modal("hide");
            this.loading = false;
          },
          (err) => {
            this.loading = false;
            toastr.error(err.data.Message);
          }
        );
    },
    requestManuelBonus() {
      if (this.loading) {
        this.console.log("Already request is in Creation!");
        return;
      }

      this.loading = true;

      if (this.shouldDisplayDebitAmount && this.manuel.debitAmount === "") {
        this.manuel.debitAmount = "99999";
      }

      if (this.manuel.amount >= 5000) {
        Swal.fire({
          title:
            "Müşteriye 5000 TL Üzeri Bir Bonus Eklemesi Yapmak Üzeresiniz!",
          showCancelButton: true,
          confirmButtonText: "Evet! Yapılsın",
          cancelButtonText: "Hayır! Yapılmasın",
          icon: "question",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.$http.post("Bonus/RequestManuelAddBonus/", this.manuel).then(
              (response) => {
                toastr.success("Manuel bonus talebiniz başarıyla alındı.");

                $("#manuel-bonus").modal("hide");
                this.loading = false;
              },
              (err) => {
                this.loading = false;
                toastr.error(err.data.Message);
              }
            );
          } else {
            // 👇 If user cancels, make sure to reset loading
            this.loading = false;
            toastr.info("İşlem iptal edildi.");
          }
        });
      } else {
        this.$http.post("Bonus/RequestManuelAddBonus/", this.manuel).then(
          (response) => {
            toastr.success("Manuel bonus talebiniz başarıyla alındı.");

            $("#manuel-bonus").modal("hide");
            this.loading = false;
          },
          (err) => {
            this.loading = false;
            toastr.error(err.data.Message);
          }
        );
      }
    },
    requestInsiyatifBonus() {
      this.$http.get("Bonus/RequestInsiyatif/" + this.insiyatif.code).then(
        (response) => {
          toastr.success("İnsiyatif hesaplama talebiniz başarıyla alındı.");

          $("#request-insiyatif").modal("hide");
        },
        (err) => {
          toastr.error(err.data.Message);
        }
      );
    },
    requestTc() {
      this.$http.post("Customer/TcControl", this.tc).then(
        (response) => {
          toastr.success(response.data);

          $("#request-tc").modal("hide");
        },
        (err) => {
          toastr.error(err.data.Message);
        }
      );
    },
    requestTcQuick() {
      this.$http.post("Customer/TcControlQuick", this.quick).then(
        (response) => {
          toastr.success(response.data);

          $("#request-tc-quick").modal("hide");
        },
        (err) => {
          toastr.error(err.data.Message);
        }
      );
    },
    requestDepositRemove() {
      this.$http.post("Finance/DeleteDeposit/", this.deposit).then(
        (response) => {
          toastr.success("Yatırım kayıtları başarıyla silindi.");
          $("#request-deposit-remove").modal("hide");
        },
        (err) => {
          toastr.error(
            "İşlem sırasında bir hata oluştu! Lütfen tekrar deneyiniz."
          );
        }
      );
    },
    logout() {
      this.$store.dispatch("logout");
    },
    siteChange() {
      this.$store.commit("setSite", this.site);
    },
    openFileUploadModal() {
      this.selectedFile = null;
      this.cekilis = 0;
      console.log("abc");
      $("#file-upload-modal").modal();
    },
    handleFileUpload(event) {
      this.selectedFile = event.target.files[0];
    },
    onClearSelection() {
      this.selectedFile = null;
    },
    sendData() {
      if (!this.loading) {
        this.loading = true;
        var postData = new FormData();
        postData.append("file", this.selectedFile);
        //postData.append('cekilis', this.cekilis);

        this.$http
          .post("Report/GenerateTickets/", postData)
          .then(
            (response) => {
              toastr.success("Records Uploaded.");
              this.reset();
              $("#modal").hide();
              window.location.reload();
            },
            (err) => {
              toastr.error(err.data.Message);
            }
          )
          .finally(() => {
            this.loading = false; // Set loading back to false after API request completes
            $("#fileUploader").val("");
            this.cekilis = 0;
          });
      }
    },
  },
  watch: {
    "$store.getters.getSite"() {
      this.site = this.$store.getters.getSite;
      this.request.bonus = null;
      this.manuel.bonus = null;
      this.getAllBonus();
    },
    "manuel.type"() {
      console.log(this.manuel);
      this.manuel.transaction = "";
      this.manuel.amount = "";
      this.manuel.freespin = 0;
      this.manuel.bonus = null;
      this.$v.$reset();

      if (this.manuel.type == 7 || this.manuel.type == 8) {
        this.manuel.bonus = 0;
        this.manuel.transaction = "0";
        this.manuel.amount = 0;
      }
    },
    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
    },
  },
  created() {
    this.getCekilis();
  },
};
</script>

<style scoped>
.header-height {
  height: auto;
}

.btn-theme {
  color: rgba(0, 0, 0, 0.5);
  padding: 0px 10px;
  border-radius: 4px;
  transition: 0.3s all ease;
}

.bg-dark {
  background-color: #343a40;
}

.btn-theme:hover {
  background-color: #dddddd;
  cursor: pointer;
}

.btn-logout > i,
.btn-theme > i {
  font-size: 1.7rem;
}

.header-list {
  min-width: 15rem;
  height: 2.6rem;
  font-size: 1.1rem;
}

.nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* THEME TOGGLE SWITCH */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: fit-content;
  margin: 0;
}

.switch input[type="checkbox"] {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #2b2b2b;
  transition: 0.4s;
  border-radius: 20px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 3px;
  bottom: 4px;
  background-color: #f0f0f0;
  transition: 0.4s;
  border-radius: 50%;
}

input[type="checkbox"]:checked + .slider {
  background-color: #f0f0f0;
}

input[type="checkbox"]:checked + .slider:before {
  transform: translateX(29px);
  background-color: #2b2b2b;
  height: 16px;
  width: 16px;
}

.switch-container {
  display: flex;
  align-items: center;
  gap: 15px;
  border: 2px solid #a1a1a175;
  border-radius: 10px;
  padding: 8px 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue